import $ from 'jquery'

export function init() {
  $('[data-page-nav]').each((i, elem) => {
    $(elem)
      .find('a[href*="#"]')
      .each((i, link) => {
        const $link = $(link)
        const anchor = $link.attr('href').substring(1)
        if ($('a[name="' + anchor + '"]').length) {
          $link.on('click', (event) => {
            event.preventDefault()
            const position = $('a[name="' + anchor + '"]')
              .first()
              .position().top
            const scroll = $(window).scrollTop()
            const time = Math.min(Math.abs(scroll - position) / 3, 1500) // distance / 3, or 1.5 seconds max
            $('html, body').animate({ scrollTop: position }, time, 'swing')
            window.history.replaceState(
              window.history.state,
              document.title,
              `${window.location.origin}${window.location.pathname}${window.location.search}#${anchor}`
            )
          })
        }
      })
  })
}
